module.exports = __webpack_public_path__ + "static/media/eh.61674b9f.svg";